import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import users from "../../../../users";
import "./seasonSelector.css";
import { isMediumScreen } from "../../../../../utils/utils";
import { ScrollModal } from "../../../../shared/scroll-modal";
import { OptionButton } from "../../../../shared/option-button";
import { CustomSelectorV2 } from "../../../../shared";

function SeasonSelector({ seasons, selectedSeason, setSelectedSeason }) {
    const darkMode = useSelector(users.selectors.isDarkMode);
    const [open, setOpen] = useState(false);
    const scrollModalRef = React.useRef(null);

    const selectedObj = useMemo(() => {
        return seasons.find(s => s.season_number == selectedSeason);
    }, [seasons, selectedSeason]);

    if (!seasons || selectedSeason == null || seasons.length <= 1) {
        return null;
    }

    return (
        <div className="season-selector-container mt-3" style={{
            position: "relative",
            zIndex: 2,
            justifyContent: !isMediumScreen() ? "end" : "center",
        }}>
            {!isMediumScreen() ? (
                <CustomSelectorV2
                    value={selectedSeason.toString()}
                    onChange={(val) => setSelectedSeason(Number(val))}
                    options={seasons.map((season) => ({
                        label: season.name,
                        value: season.season_number.toString(),
                    }))}
                    width="170px"
                />
            ) : (
                <>
                    {/* "input" custom */}
                    <div
                        className="season-selector-input"
                        style={{
                            width: "100%",
                        }}
                        onClick={() => {
                            if (scrollModalRef.current) {
                                scrollModalRef.current.open();
                            } else {
                                setOpen(!open);
                            }
                        }}
                    >
                        <span style={{
                            width: "calc((100% - 170px) / 2)", backgroundColor: !darkMode
                                ? "rgba(33,37,41,0.5)" // #212529 con transparencia
                                : "rgba(255,255,255,0.5)", height: "1px"
                        }}></span>
                        <span>{selectedObj?.name}</span>
                <span className="arrow">{open ? "▲" : "▼"}</span>
                        <span style={{ width: "calc((100% - 170px) / 2)", backgroundColor: !darkMode
                                ? "rgba(33,37,41,0.5)" // #212529 con transparencia
                                : "rgba(255,255,255,0.5)", height: "1px" }}></span>
                    </div>

                    <ScrollModal ref={scrollModalRef}>
                        {seasons.map((season) => (
                            <OptionButton
                                key={season.season_number}
                                style={{
                                    justifyContent: "center"
                                }}
                                active={season.season_number == selectedSeason}
                                onClick={() => {
                                    setSelectedSeason(season.season_number);
                                    setOpen(false);
                                    if (scrollModalRef.current) scrollModalRef.current.close();
                                }} text={season.name} icon={undefined}
                            />
                        ))}
                    </ScrollModal>
                </>
            )}
        </div>
    );
}

export default SeasonSelector;
